var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import { updateBuildingAttachment } from '../services/buildingAttachmentsApi';
import { buildingAttachmentsKeys } from './queryKeys';
const ERRORS_NS = 'features.building_attachments.edit_modal.errors';
function extractErrorMessage(error) {
    var _a, _b;
    const axiosError = error;
    return ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || axiosError.message || translate('generic', { namespace: ERRORS_NS });
}
export function useAttachmentFieldCommit(buildingId, attachmentId) {
    const queryClient = useQueryClient();
    const commit = useCallback((payload) => __awaiter(this, void 0, void 0, function* () {
        try {
            const row = yield updateBuildingAttachment(buildingId, attachmentId, payload);
            queryClient.setQueryData(buildingAttachmentsKeys.list(buildingId), (rows) => rows === null || rows === void 0 ? void 0 : rows.map((existing) => (existing.id === attachmentId ? row : existing)));
            return { success: true, row };
        }
        catch (error) {
            return { success: false, error: extractErrorMessage(error) };
        }
    }), [buildingId, attachmentId, queryClient]);
    return { commit };
}
